/*
 * @Description:终端支付管理
 * @Date: 2022-09-19 14:37:49
 */
import http from '@/utils/http/axios';
import { ContentTypeEnum } from '@/utils/http/axios/enums';
import { money } from 'xrk-tools';
import {
  TerminalPayDetailTranslator,
  TerminalPayListTranslator
} from './translators';
import {
  TerminalPayDetailResult,
  TerminalPayList,
  TerminalPayListParams
} from './types';
enum Api {
  list = '/front-end/asp-terminal-payment/list',
  listAmount = '/front-end/asp-terminal-payment/listAmount',
  export = '/front-end/asp-terminal-payment-export/export',
  id = '/front-end/asp-terminal-payment/id',
  projectList = '/front-end/asp-terminal-payment/projectList',
  industryList = '/front-end/asp-terminal-payment/industryList',
  supplierList = '/front-end/asp-terminal-payment/supplierList'
}
export const getTerminalPayList: TerminalPayList = async params => {
  const res = await http.request(
    {
      url: Api.list,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-type': ContentTypeEnum.JSON
      }
    }
  );
  return TerminalPayListTranslator(res);
};

export const getTerminalPayListAmount = async (
  params: TerminalPayListParams
) => {
  const res = await http.request<Result<{ amount: number | string }>>(
    {
      url: Api.listAmount,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-type': ContentTypeEnum.JSON
      }
    }
  );
  res.data.amount = money.moneyFixed(res.data.amount || 0);
  return res;
};
export const exportTerminalPayListUrl = params =>
  http.download(
    {
      url: Api.export,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );
export const exportTerminalPayList: TerminalPayList = async params => {
  const res = await http.request(
    {
      url: Api.export,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-type': ContentTypeEnum.JSON
      }
    }
  );
  return res;
};
export const getTerminalPayDetail = async (params: {
  projectId: string;
  projectType: string | number;
  fullName?: string;
  phone?: string;
  customOrderId: string | number;
}) => {
  const projectType = params.projectType;
  delete params.projectType;
  const res = await http.request<Result<TerminalPayDetailResult>>({
    url: Api.id,
    method: 'POST',
    params
  });
  return TerminalPayDetailTranslator(res, projectType);
};

export const select = {
  getProjectList: async (params: {
    type: TerminalPayListParams['type'];
    keyWord?: string;
  }) => {
    const res = await http.request(
      {
        url: Api.projectList,
        method: 'POST',
        params
      },
      {
        isParseToJson: true,
        headers: {
          'Content-type': ContentTypeEnum.JSON
        }
      }
    );
    return res;
  },
  getIndustryList: async (params: {
    type: TerminalPayListParams['type'];
    keyWord?: string;
  }) => {
    const res = await http.request(
      {
        url: Api.industryList,
        method: 'POST',
        params
      },
      {
        isParseToJson: true,
        headers: {
          'Content-type': ContentTypeEnum.JSON
        }
      }
    );
    return res;
  },
  getSupplierList: async (params: {
    type: TerminalPayListParams['type'];
    keyWord?: string;
  }) => {
    const res = await http.request(
      {
        url: Api.supplierList,
        method: 'POST',
        params
      },
      {
        isParseToJson: true,
        headers: {
          'Content-type': ContentTypeEnum.JSON
        }
      }
    );
    return res;
  }
};
